import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import NewApp from './NewApp'
import AppRouter from './AppRouter';
//import App from './App.tsx'
//import MainDashboard from './MainDashboard.tsx'
import { HelmetProvider } from 'react-helmet-async'   // 추가


createRoot(document.getElementById('root')!).render(
  // <StrictMode>
    <HelmetProvider>   {/* 여기서 전체를 감쌈 */}
      <AppRouter />
    </HelmetProvider>
  // </StrictMode>,
)
